import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Logo from "../../components/Logo";
import ImportLocations from './ImportLocations';
import SquareLocationImporter from './SquareLocationImporter';
import * as URLS from '../../const/URL.const';

import ESquareRedirectCode from '../../interfaces/ESquareRedirectCode';

import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import merchantAPIDefs from "../../yoello-lib/modules/API2/APIDefs/";
import StageChecklist from "../../yoello-lib/modules/components/UI/Lists/StageChecklist";

export interface IMerchant {
    first_name: string;
    last_name: string;
}
export interface IVenueImporterView {
    
}

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%",

        position: "relative",
        display: "flex",
        "@media (max-width: 600px)": {
            flexDirection: "column"
        }
    },
    logoWrapper: {
        width: "100%",
        position: "relative"
    },  
    welcome: {
        fontSize: "1.5rem",
        fontWeight: 400,
        marginBottom: "0",
        marginTop: "2rem"

    },
    name: {
        marginTop: "0",
        fontWeight: 600,
    },
    follow: {
        marginTop: "3.5rem",
        marginBottom: "1.3rem",
        fontSize: "1.2rem",
        color: "#737FA4",
        fontWeight: 600
    },
    sideBar: {
        padding: "2rem 5rem",
        flex: "0 0 30rem",
        height: "100%",
        backgroundColor: "#F3F4F9",
        "@media (max-width: 960px)": {
            padding: "1rem 2rem",
            display: "flex",
            flexDirection: "column"
        }

    },
    content: {
        position: "relative",
        flex: "1 1 auto",
        padding: "0 5vw",
        backgroundColor: "#FFFFFF",
        "@media (max-width: 960px)": {
            padding: "1rem 2rem",
            display: "flex",
            flexDirection: "column"
        }
    },
})

const VenueImporterView = (props: IVenueImporterView) => {
    const { apiData, isError } = useAPIV2<IMerchant[]>(merchantAPIDefs.merchants, {});
    const [ fullName, setFullName ] = useState("");
    const [ csrfToken, setCrsfToken ] = useState("");
    const [ currentStage, setCurrentStage ] = useState(0);
    const { t } = useTranslation();
    const { pathname, search } = useLocation();
    const classes = useStyles();

    const redirectError = new URLSearchParams(search).get("error");
    const stateToken = new URLSearchParams(search).get("state");

    useEffect(() => {
        if(apiData && !isError){
            const data = apiData as IMerchant[];
            setFullName(`${data[0].first_name} ${data[0].last_name}`)
        }
    }, [apiData, isError]);

    useEffect(() => {
        const token = stateToken || `${ESquareRedirectCode.SIGNUP}_${uuidv4()}`;
        setCrsfToken(token);
        localStorage.setItem('square-csrf', token);
        //eslint-disable-next-line
    }, [])


    useEffect(() => {
        switch(pathname) {
            case URLS.VENUE_IMPORTER_URL:
                setCurrentStage(0);
                break;
            case URLS.SQUARE_LOCATION_URL:
                setCurrentStage(1);
                break;
            default:
                setCurrentStage(0);
                break;
        }

    }, [pathname]);

    const renderContent = () => {
        switch(currentStage){
            case 0: 
                return <ImportLocations error={redirectError} csrfToken={csrfToken} />
            case 1: 
                return <SquareLocationImporter />
            default:
                return <ImportLocations error={redirectError} csrfToken={csrfToken} />
        }
    }
    return (
        <div className={classes.root}>
            <div className={classes.sideBar}>
                <div className={classes.logoWrapper}>
                    <Logo />
                </div>
                
                <h2 className={classes.welcome}>{t("signup.importer.welcome")}</h2>
                <h2 className={classes.name}>{fullName}</h2>
                <p className={classes.follow}>{t("signup.importer.follow_steps")}</p>
                <StageChecklist 
                    list={[
                        {displayName: t("signup.importer.import_locations")},
                        {displayName: t("signup.importer.select_locations")},
                        {displayName: t("signup.importer.go_to_merchant")},
                    ]}
                    current={currentStage}
                />
            </div>
            <div className={classes.content}>
                {renderContent()}
            </div>
        </div>
    )
}

export default VenueImporterView;